import { render, staticRenderFns } from "./DeviceDetailsReviewsSkeleton.vue?vue&type=template&id=274f3d3f&"
import script from "./DeviceDetailsReviewsSkeleton.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailsReviewsSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274f3d3f')) {
      api.createRecord('274f3d3f', component.options)
    } else {
      api.reload('274f3d3f', component.options)
    }
    module.hot.accept("./DeviceDetailsReviewsSkeleton.vue?vue&type=template&id=274f3d3f&", function () {
      api.rerender('274f3d3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/devicereviews/DeviceDetailsReviewsSkeleton.vue"
export default component.exports